import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Handles scroll behaviour on route change:
 * - When the URL has a hash, smooth-scrolls to the matching element (react-router
 *   does not handle hash scrolling on its own, and section anchors are shared
 *   across pages).
 * - When there is no hash, jumps to the top so every navigation starts from the
 *   top of the new page instead of keeping the previous scroll position.
 */
export function useScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      return;
    }
    const id = hash.replace('#', '');
    const timer = window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
    return () => window.clearTimeout(timer);
  }, [pathname, hash]);
}